import { Component } from '@angular/core';
import { NzFlexModule } from 'ng-zorro-antd/flex';

@Component({
  selector: 'math-survey-info',
  imports: [NzFlexModule],
  templateUrl: './survey-info.component.html',
  styleUrl: './survey-info.component.scss',
})
export class SurveyInfoComponent {}
